<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :footer="null" :confirmLoading="loading" :maskClosable="false" @cancel="cancel"
>
      <div slot="title">查看</div>
      <div>
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="产品名称">
            <a-select
                    disabled
                    v-model="form.name"
                    style="width: 100%"
            >
              <a-select-option
                      v-for="val in productList"
                      :key="val.id"
                      :value="val.name + '-' + val.id"
              >
                {{ val.name }} ({{ val.id }})
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="sales_area" label="销售区域">
            <a-input disabled v-model="form.sales_area" />
          </a-form-model-item>
          <!-- <a-form-model-item prop="period" label="产品保质期">
            <a-input disabled v-model="form.period" />
          </a-form-model-item> -->
          <a-form-model-item prop="commpany" label="生产企业">
            <a-textarea disabled v-model="form.commpany" />
          </a-form-model-item>
          <a-form-model-item prop="adreess" label="生产地址">
            <a-textarea disabled v-model="form.adreess" />
          </a-form-model-item>
          <a-form-model-item prop="introduce" label="产品介绍">
            <a-input disabled v-model="form.introduce" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="联系方式">
            <a-input disabled v-model="form.remark" />
          </a-form-model-item>
          <!-- <a-form-model-item prop="bar_code" label="条形码">
            <a-input disabled v-model="form.bar_code" />
          </a-form-model-item> -->
          <a-form-model-item prop="licence_no" label="许可证编号">
            <a-input disabled v-model="form.licence_no" allowClear />
          </a-form-model-item>
          <a-form-model-item prop="ingredients" label="配料表">
            <a-textarea disabled v-model="form.ingredients" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "FromProductView",
  model: { prop: "visible", event: "cancel" },
  props: ["visible", "form", "clientsClassificationOptions"],
  data() {
    return {
      rules: {},
      loading: false,
      localVisible: this.visible,
    };
  },
  computed: {
    productList() {
      if (!this.form || !this.form.product_id) return [];
      return [{ id: this.form.product_id, name: this.form.product_name || '' }];
    }
  },
  watch: {
    visible(v) { this.localVisible = v; },
  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
